module.exports = __webpack_public_path__ + "static/img/section_06_celestion_kv.dda5284.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/overview/section_06_celestion_kv.png
// module id = Eghd
// module chunks = 12